import { Component, h, State, Event, EventEmitter, Listen, Host } from '@stencil/core';
import { inputOut } from '../../utils/utils';
import { reauthenticateWithCredential, EmailAuthProvider, updatePassword} from "firebase/auth";
import { FirebaseService } from '../../utils/firebase';
import { addStyleSettings } from '../../utils/custom-style';
import { customer } from '../../store/customer.store';


@Component({
  tag: 'tambr-auth-password-update-modal',
  styleUrl: 'tambr-auth-password-update-modal.css',
  shadow: true,
})
export class TambrAuthPasswordUpdateModal {

  @Event() tambrChangePasswordSuccess: EventEmitter;
  @Event() tambrChangePasswordClose: EventEmitter;

  @State() oldPassword: string = '';
  @State() newPassword: string = '';

  @State() errorMessages: string[] = [];
  @State() submitLoading: boolean = false;

  @Listen('click') onClickEvent( ev: MouseEvent ) {
    const targets = ev.composedPath() as EventTarget[];
    if (targets[0] instanceof Element && targets[0].id === 'tambr-password-change-form') return this.close();
  }

  addErrorMessage(message: string) { this.errorMessages = [ ...this.errorMessages, message ]; }

  handleOldPasswordChange(event) { this.oldPassword = event.target.value; }
  handleNewPasswordChange(event) { this.newPassword = event.target.value; }

  validate() {
    if (this.oldPassword == '') this.addErrorMessage("Old password field can't be empty");
    if (this.newPassword == '') this.addErrorMessage("New password field can't be empty");
  }

  async handleSubmit(ev: any) {
    ev.preventDefault();
    if (this.submitLoading) return;

    this.errorMessages = [];
    this.submitLoading = true;

    this.validate();

    if (!this.errorMessages.length){
    try{
      const credential = EmailAuthProvider.credential(
        customer.platformCustomer.email,
        this.oldPassword
      );
      await reauthenticateWithCredential(FirebaseService.auth.currentUser, credential)
      await updatePassword(FirebaseService.auth.currentUser, this.newPassword);
      this.tambrChangePasswordSuccess.emit()
      this.tambrChangePasswordClose.emit();
    } catch(error) {
      switch(error.code){
        case 'auth/wrong-password':
          this.addErrorMessage('Your old password is wrong.'); 
          break;
        case 'auth/weak-password':
          this.addErrorMessage('This password is too weak.');
          break;
        default:
          this.addErrorMessage(error.message);
      }
    }
  }
    this.submitLoading = false;
  }

  close() { 
    if (this.submitLoading) return;
    this.tambrChangePasswordClose.emit();
  }

  renderMessages(messages: string[]) {
    return (
      <ul>
        { messages.map( (message: string) => 
          <li>{ message }</li>
        ) }
      </ul>
    );
  }

  render() {
    return (
      <Host style={ addStyleSettings() }>
        <form id="tambr-password-change-form" class="tambr-overlay" onSubmit={ ev => this.handleSubmit(ev) } >
          <div class="tambr-modal-window">
            
            <div class="tambr-modal-header">
              <tambr-icon type="close" class="close-button" onClick={ () => { this.close() } } />
            </div>

            <div class="tambr-modal-title">Change Password</div>

            <div class="tambr-modal-body">
            <div class={'error message' + (this.errorMessages.length ? ' show' : '') }>
            { this.renderMessages(this.errorMessages) }
            </div>

              <div class="tambr-form-item">
                <input type="password" id="old-password" name="old-password"
                  value={ this.oldPassword } 
                  onInput={ (event) => this.handleOldPasswordChange(event) }
                  onBlur={ (event) => inputOut(event) } />
                <label htmlFor="old-password">Old Password</label>
              </div>

              <div class="tambr-form-item">
                <input type="password" id="new-password" name="new-password"
                  value={ this.newPassword } 
                  onInput={ (event) => this.handleNewPasswordChange(event) }
                  onBlur={ (event) => inputOut(event) } />
                <label htmlFor="new-password">New Password</label>
                <div class={"password-hint"}>Password should contain at least 6 characters</div>
              </div>
              
              <div class="tambr-action-buttons stacked">
                <button type="submit" disabled={ this.submitLoading }
                  class={ 'tambr-button' + (this.submitLoading ? ' loading' : '') }>
                    <div class="tambr-button-loading"><div>Loading...</div></div>
                    <span>Change password</span>
                </button>
                <a class="tambr-clear-button" onClick={ () => { this.close() } } >Dismiss</a>
              </div>
            </div>

          </div>
        </form>
      </Host>
    );
  }

}
